import React from 'react';
import Link from '../Link/Link';

import './index.scss';

export default function Cta({ cta = null, variant = null }) {
  return (
    <Link to={cta} className={`custom-btn ${variant ? variant : ''}`}>
      {cta?.label}
    </Link>
  );
}
